<template>
  <!-- Boutons de sélection -->
  <div class="p-4 d-flex justify-content-around">
    <div class="form-check form-switch">
      <div class="d-flex">
        <div class="h6 col-5">Exemples de remboursements</div>
        <div class="col-1">
          <input
            id="flexSwitchCheckDefault"
            class="form-check-input"
            type="checkbox"
            role="switch"
            data-cy="select-table"
            @click="onTabClick(!isTabExample)"
          >
        </div>
        <div class="h6 col-5">Tableau de garanties complet</div>
      </div>
    </div>
  </div>

  <div class="p-4">
    <slot />

    <!-- Exemples de remboursements -->
    <div
      v-for="(value, index) in refundExampleTables"
      v-show="isTabExample"
      :key="index"
      class="py-4"
      data-cy="refund-example-table"
    >
      <div class="h3 py-2">
        {{ value.label }}
      </div>
      <sl-table
        :tag="value.label"
        :columns="value.columns" 
        :datas="value.datas"
        :current-position-selected="currentPositionsSelected[value.label]"
        v-bind="$props"
        @cell-mouseover="$emit('cell-mouseover', $event)"
        @cell-click="$emit('cell-click', $event)"
      />
    </div>

    <!-- Tableau de garanties -->
    <div
      v-for="(value, index) in warrantyTables"
      v-show="!isTabExample"
      :key="index"
      class="py-4"
      data-cy="warranty-table"
    >
      <div
        class="h3 py-2"
        style="cursor: pointer"
        @click="toggleExpand(index)"
      >
        <span
          class="icon"
          :class="{opened: expand[index]}"
          data-cy="action-expand"
        >>></span> {{ value.label }} <br>
        <span class="h6">Cliquez ici pour voir le détail des garanties</span>
      </div>
      <sl-table
        :tag="value.label"
        :columns="value.columns" 
        :datas="value.datas"
        :current-position-selected="currentPositionsSelected[value.label]"
        v-bind="$props"
        :expand="expand[index]"
        @cell-mouseover="$emit('cell-mouseover', $event)"
        @cell-click="$emit('cell-click', $event)"
      />
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, ref } from 'vue'
import SlTable from 'src/modules/shared/components/Table/SlTable'

/**
 * Tarificateur SwissLife
 * Il prend en entrée 2 listes de tableaux
 * correspondant aux exemples et aux valeurs de garanties
 */
export default {
  name: 'SlPricer',
  components: { SlTable },
  props: {
    // les tableaux d'exemples de tarification
    refundExampleTables: {
      type: Array,
      required: true
    },
    // les tableaux de valeurs réelle de tarification
    warrantyTables: {
      type: Array,
      required: true
    },
    currentPositionsSelected: {
      type: Array,
      required: true
    },
    // l'écart +/- autour de la selection
    range: {
      type: Number,
      required: false,
      default: 1
    }
  },
  emits: [
    'cell-click',
    'cell-mouseover'
  ],
  setup() {
    const state = reactive({
      isTabExample: true,
    })

    const expand = ref([])

    const toggleExpand = (index) => {
      expand.value[index] = !expand.value[index]
    }

    /**
     * Affiche les exemples à la place des valeurs et vice-versa
     */
    const onTabClick = (isTabExample) => {
      state.isTabExample = isTabExample
    }

    return {
      expand,
      toggleExpand,
      onTabClick,
      ...toRefs(state)
    }

  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.h3 {
  margin-left: 2rem;
  .icon {
    position: absolute;
    transition: transform 0.5s;
    transform: translateX(-2rem) scale(0.5, 1.5);

    &.opened {
      transform: translateX(-2rem) rotate(90deg) scale(0.5, 1.5);
    }
  }
}

.form-switch .form-check-input:checked {
  background-color: $red !important;
  border-color: $red !important;
}

#app .form-switch #flexSwitchCheckDefault {
  height: 2rem;
  width: calc(3rem + 0.75rem);
  border-radius: 4rem;
}
</style>